<template>
    <div class="coffee-index-home">
        <div v-if="isSearchBar">
                <coffee-search-bar
                :filter-params="filterParams"
                :include-price-sort="true"
                :preset-filter-params="presetFilterParams"
                :top-shelf="true"
                @queryParamsUpdated="searchParamsUpdated"
                ref="searchBar"
            />
        </div>
        <div :class="{'top-padded': anyFilterPillsDisplayed}">
            <transition name="fade-fast" mode="out-in">
                <div v-if="loading" class="spinner-wrapper" key="loading">
                    <loading-spinner />
                </div>
                <div v-else>
                    <div v-if="searchingResult">
                        <div v-if="coffeeSearchResults.length > 0 || specificCategories.length > 0">
                            <div v-if="(selectFilter != undefined && selectFilter['brew_methods'].length === 1) && (selectFilter['brew_methods'].includes('espresso') || selectFilter['brew_methods'].includes('cold_brew'))">
                                <coffee-espresso-list
                                    :categories="specificCategories"
                                    :playlist-data="playlistData"
                                    :brewlist-detail="brewlistDetails"
                                    :buy-now-props="buyNowProps"
                                    v-on:add-coffee-to-playlist="addCoffeeToPlaylist"
                                />
                            </div>
                            <div v-else>
                                <coffee-card-list
                                    :paramfilter=this.selectFilter
                                    :coffees="coffeeSearchResults"
                                    :carousel="carousel"
                                    :playlist-data="playlistData"
                                    :brewlist-detail="brewlistDetails"
                                    :buy-now-props="buyNowProps"
                                    v-on:add-coffee-to-playlist="addCoffeeToPlaylist"
                                />
                                <infinite-loading v-if="this.page !== 1" @infinite="loadMoreResults" spinner="circles">
                                    <span slot="no-more"></span>
                                    <span slot="no-results"></span>
                                </infinite-loading>
                            </div>
                        </div>
                        <div v-else class="noResultMessage centered">
                            <strong>Sorry, we couldn't find any coffees matching. </strong>
                        </div>
                    </div>
                    <div v-else>
                        <coffee-card-list
                            :coffees="coffees"
                            :carousel="carousel"
                            :playlist-data="playlistData"
                            :brewlist-detail="brewlistDetails"
                            :buy-now-props="buyNowProps"
                            v-on:add-coffee-to-playlist="addCoffeeToPlaylist"
                        />
                    </div>
                </div>
            </transition>
        </div>
    </div>

</template>

<script>
    import CoffeeCardList from "./coffee-card-list-home";
    import CoffeeEspressoList from"./coffee-espresso-list-home";
    import CoffeeSearchBar from "../common/coffee-search-bar";
    import CoffeeMixin from "../../mixins/coffee-mixin";
    import LoadingSpinner from "../common/loading-spinner";
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            CoffeeCardList,
            CoffeeEspressoList,
            CoffeeSearchBar,
            LoadingSpinner,
            InfiniteLoading
        },
        mixins: [
            CoffeeMixin
        ],
        props: {
            coffees: Array,
            buyNowProps: Object,
            filterParams: Object,
            brewlistDetails: Object,
            isSearchBar: Boolean,
            carousel: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                playlistData: undefined,
                presetFilterParams: [],
                searchParams: [],
                loading: false,
                numCoffeesPerLoad: 20,
                coffeeSearchResults: undefined,
                selectFilter: undefined,
                specificCategories: [],
                searchingResult: false
            }
        },
        methods: {
            searchParamsUpdated(searchParams) {
                this.page = 1;
                if (searchParams['search'] || searchParams['filter'] || searchParams['sort']) {
                    this.searchingResult = true
                    this.selectFilter = searchParams['filter'];
                    if ((this.selectFilter !== undefined && this.selectFilter.brew_methods.length === 1) && (this.selectFilter.brew_methods.includes("espresso") || this.selectFilter.brew_methods.includes("cold_brew"))){
                        this.searchParams = searchParams;
                        this.searchForSpecificKeyword();
                    }else{
                        this.searchParams = searchParams;
                        this.updateSearchResults();
                    }
                } else {
                    this.searchingResult = false;
                    this.specificCategories=[];
                    this.coffeeSearchResults = undefined;
                }
                this.scrollToTop();
            },
            updateSearchResults(){
                this.loading = true;
                let params = {
                        topShelf: true,
                        page: this.page,
                        per: this.numCoffeesPerLoad,
                        includePrice: this.isAdmin,
                        ...this.searchParams
                    }
                this.$api.get('/v1/coffees', {params: params})
                    .then( res => {
                        this.coffeeSearchResults = res.data;
                        this.loading = false;
                        if (!res.data || res.length === 0) {
                            $state.complete();
                        }
                    })
                    .catch( err => {
                            console.error(err);
                            this.loading = false;
                        }
                    );
                this.page++;
            },
            searchForSpecificKeyword(){
                this.loading = true;
                let params = {
                        topShelf: true,
                        page: this.page,
                        per: this.numCoffeesPerLoad,
                        includePrice: this.isAdmin,
                        ...this.searchParams
                    }
                this.$api.get('/v1/coffees/espresso_only', {params: params})
                    .then( res => { 
                        this.specificCategories = res.data.map(r=> r.coffee_detail);
                        this.loading = false;
                        if (!res.data || res.length === 0) {
                            $state.complete();
                        }
                    })
                    .catch( err => {
                            console.error(err);
                            this.loading = false;
                        }
                    );
            },
            scrollToTop() {
                this.$refs.searchBar.scrollToTop();
            },
            loadMoreResults($state) {
                let params = {
                        topShelf: true,
                        page: this.page,
                        per: this.numCoffeesPerLoad,
                        includePrice: this.isAdmin,
                        ...this.searchParams
                    }
                this.$api.get('/v1/coffees', {params: params})
                    .then( res => {
                        if (res.data.length < this.numCoffeesPerLoad) {
                            $state.complete();
                        } else {
                            $state.loaded();
                        }
                        this.coffeeSearchResults.push(...res.data);
                    })
                    .catch(console.error);
                this.page++;
            },
            addCoffeeToPlaylist(coffeeId, size, grind) {
                // TODO: Implement this method in order to decouple vue components from add.js
                // if (!this.playlistData) {
                //     console.error('Error: playlistData is not defined.');
                //     return;
                // }
                //
                // const newItem = {
                //     item_id: coffeeId,
                //     item_type: 'product',
                //     size: size,
                //     grind: grind,
                // };
                //
                // this.playlistData.items.push(newItem);
                // // Save it in cookie
                // if ( getUserId() == null ) {
                //     Cookies.set('blids', this.getProductIds(data));
                //     Cookies.set('frq', data.frequency);
                // }
                //
                // this.$api.patch('v1/users/me/brewlist', this.playlistData)
                //     .then(res => {
                //         this.playlistData = res.data;
                //         if (this.playlist.force_process_next_batch)
                //         this.fetchProducts();
                //         this.$emit('refresh-suggestions');
                //     })
                //     .catch((err) => console.error(err)) // TODO: Toggle back if error
            }
        },
        computed: {
            anyFilterPillsDisplayed: function() {
                if (!this.searchParams || !this.searchParams.filter) {
                    return false;
                }
                for (let key of Object.keys(this.searchParams.filter)) {
                    if (this.searchParams.filter[key].length) {
                        return true;
                    }
                }
                return false;
            },
        },
        mounted() {
            this.$api.get('v1/users/me/brewlist')
                .then( (res) => this.playlistData = res.data)
                .catch(console.error);
        }
    }
</script>

<style lang="scss" scoped>
    @import "./../../styles/variables_home";
    .coffee-index-home {
        padding-bottom: 4rem;
    }
    .top-padded {
        padding-top: 1.5rem;
    }
    .noResultMessage {
        margin-top: 30vh;
        text-align: center;
    }
    .spinner-wrapper {
        min-height: 50vh;
        display: flex;
        align-items: center;
    }

    @media only screen and (max-width: $max-tablet-width) {
        .top-padded {
            padding-top: 4rem;
        }
    }
</style>

<!-- HACK: Styles for the child components are overwritten in this hacky way. -->
<style lang="scss">
    @import "../../styles/common_home";
    @import "./../../styles/variables_home";

    * {
        font-family: "futura-pt"!important;
    }
    a {
        text-decoration: none!important;
    }
    /* Search bar */
    .coffee-search-wrapper {
        background-color: $color-primary!important;
    }
    .coffee-search-input {
        background-color: $color-primary!important;
    }
    .coffee-search-bar {
        background-color: $white!important;
    }
    .sort-main-btn {
        background-color: $yellow!important;
        &:hover {
            background-color: darken($yellow, 5%)!important;
        }
    }
    .sort-item {
        background-color: $yellow-light!important;
        &:hover {
            background-color: darken($yellow-light, 5%)!important;
        }
    }
    .sort-pill {
        color: $white!important;
        background-color: $yellow!important;
        border-color: $yellow!important;
        &:hover {
            background-color: lighten($yellow, 10%)!important;
        }
    }
    .sort-clear-pill {
        color: $yellow!important;
        background-color: $white!important;
        border-color: $yellow!important;
        &:hover {
            color: darken($yellow, 20%)!important;
            border-color: darken($yellow, 20%)!important;
        }
    }
    .active-sort-item {
        background-color: darken($yellow-light, 15%)!important;
    }
    .filter-main-btn {
        background-color: $green!important;
        &:hover {
            background-color: darken($green, 5%)!important;
        }
    }
    .category-btn {
        background-color: $green-light!important;
        &:hover {
            background-color: darken($green-light, 5%)!important;
        }
    }
    .param-btn {
        color: darken($green, 10%)!important;
        border: solid 1px $green!important;
        &:hover {
            color: darken($green, 30%)!important;
            border-color: darken($green, 20%)!important;
        }
    }
    .active-param-btn {
        color: white!important;
        background-color: $green!important;
    }
    .added-param-pill {
        background-color: $green!important;
        &:hover {
            background-color: lighten($green, 10%)!important;
        }
    }
    .clear-pill {
        background-color: $white!important;
        color: $green!important;
        border: 1px solid $green!important;
        &:hover {
            color: darken($green, 20%)!important;
            border-color: darken($green, 20%)!important;
        }
    }

    /* 5lb Promo Bannner */
    .mobile-break {
        display: none;
    }
    .banner-5lb-promo {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: $green-light;
        margin: 50px 1rem 2rem 1rem;
        border-radius: 30px;
    }
    .banner-5lb-promo-img-wrapper {
        width: 30%;
        min-width: 400px;
        padding-left: 5%;
    }
    .banner-5lb-promo-img {
        position: absolute;
        top: -40px;
        height: 125%;
    }
    .banner-5lb-promo-content-wrapper {
        margin-bottom: 2rem;
        padding: 0 1rem;
        text-align: left;
        font-size: 22px;
        h1 {
            font-size: 34px;
            margin-bottom: 2rem;
            text-align: left;
        }
        a:hover {
            color: darken($color-primary, 10%);
        }
        .button {
            display: block;
            height: 50px;
            border-radius: 26px;
            margin-top: 3rem;
            padding: 0 3.5rem;
            background-color: $color-primary;
            &:hover {
                background-color: darken($color-primary, 10%);
            }
            &:active {
                background-color: lighten($color-primary, 10%);
            }
        }
    }

    @media only screen and (max-width: $min-desktop-sm-width) {
        .banner-5lb-promo {
            flex-direction: column;
            justify-content: center;
        }
        .banner-5lb-promo-img-wrapper {
            width: 200px;
            min-width: 0;
            padding: 0;
        }
        .banner-5lb-promo-img {
            width: 200px;
            height: 200px;
        }
        .banner-5lb-promo-content-wrapper {
            text-align: center;
            padding-top: 150px;
            h1 {
                text-align: center;
            }
            .button {
                margin-left: auto;
                margin-right: auto;
            }
        }
    }
    @media only screen and (max-width: $max-tablet-width) {
        .mobile-break {
            display: block;
            content: "";
            margin-top: -4px;
        }
        .banner-5lb-promo-content-wrapper {
            font-size: 18px;
            padding-left: 1rem;
            padding-right: 1rem;
        }
        .hide-on-mobile {
            display: none;
        }
    }
</style>
